'use strict';

const _ = require('lodash');
const flat = require('flat');
const flatten = flat.flatten;
const unflatten = flat.unflatten;

class Configurable {
    constructor(obj) {
      _.extend(this, obj);
    }
    get(keypath, defaultValue) {
      return _.get(this, keypath, defaultValue);
    }
    set(keypath, val) {
      if(!this.isWritable) {
        throw new Error('Config object is read-only.');
      }
      _.set(this, keypath, val);
    }
}

class Configuration {

    constructor (options) {
        if (_.get(options, 'forceEnvironment')) {
          this.forceEnvironment = true;
        }
        this.typeCastCatalog = {
            "(TRUE|FALSE)": this.parseBoolean
        };
    }

    fromEnvironment(defaultConfig, namespace) {
        const output = {};
        const flattened = flatten(defaultConfig);
        const prefix = (namespace) ? `${namespace}_` : '';
        _.each(flattened, (val, key) => {

            const envKey = prefix.concat(key).replace(/\./g, '_').toUpperCase();

            if(envKey in process.env) {
                return _.set(output, key, this.typeCastValue(process.env[envKey]));
            }

            const camelEnvKey = key.split('.').map(str => _.snakeCase(str)).join('_').toUpperCase();

            if(camelEnvKey in process.env) {
              return _.set(output, key, this.typeCastValue(process.env[camelEnvKey]));
            }

            if (this.forceEnvironment) {
              throw new Error(`${envKey} not in environment.`);
            }

            return _.set(output, key, val);

        });
        return new Configurable(output);
    }

    normalizeString (name) {
        return (name + '').toUpperCase();
    }

    typeCastValue(value) {
        var normalizedValue = this.normalizeString(value);
        for(let typeCastRegex in this.typeCastCatalog) {
            let regex = new RegExp(typeCastRegex);
            if (regex.test(normalizedValue)) {
                return this.typeCastCatalog[typeCastRegex](normalizedValue);
            }
        }

        // If the normalizedValue does not match any regexp in the catalog,
        // we assume the value is a string and return is without any change.
        return value;
    }

    parseBoolean(value) {
        if (value == "FALSE") return false;
        return !! value;
    }
}

module.exports = Configuration;
